import {FC} from 'react'

type Props = {
  data: any
  title: string
}

const IndicatorAssessmentContent: FC<Props> = ({data, title}) => {
  // Ambil aspek unik (dari penilai pertama yang memiliki detail)
  const firstWithDetails = data?.find((d: any) => d.details && d.details.length > 0)
  const aspects =
    firstWithDetails?.details.map((detail: any) => ({
      id: detail.aspek.id,
      name: detail.aspek.nama,
      weight: detail.aspek.bobot,
    })) || []

  const calculateTotalValue = (data: any) => {
    let total = parseFloat(
      (
        data?.reduce((sum: number, item: any) => sum + (parseFloat(item.total_nilai) || 0), 0) / 3
      ).toFixed(2)
    )

    return total
  }

  return (
    <div className='card'>
      <div className='p-7 border-bottom'>
        <div className='d-flex align-items-center gap-3'>
          <div className='icon-box px-4 py-2 rounded' style={{backgroundColor: '#EBF3FA'}}>
            <i className='fa fa-solid fa-bars text-dark'></i>
          </div>
          <p className='fs-4 fw-bold'>Indikator Penilaian</p>
        </div>
      </div>

      <div className='p-8'>
        <div className='mb-5 border border-secondary rounded'>
          {/* Header Proposal */}
          <div className='text-white p-4 rounded-top bg-primary'>
            <strong>{title}</strong>
          </div>

          <div className='table-responsive p-5'>
            <table className='table mb-0'>
              <thead style={{background: '#F5F7FA'}}>
                <tr>
                  <th className='text-center'>Kriteria</th>
                  {data?.map((assessor: any, index: any) => {
                    return (
                      <th key={index} className='text-center'>
                        {assessor.nama_penilai || 'Penilai'}
                      </th>
                    )
                  })}
                </tr>
              </thead>
              <tbody>
                {aspects?.map((aspect: any) => (
                  <tr key={aspect.id}>
                    <td className='text-start border border-secondary border-top-0 border-left-0 border-right-0'>
                      {aspect.name}
                    </td>
                    {data?.map((assessor: any, index: any) => {
                      const nilai = assessor.details?.find((d: any) => d.aspek.id === aspect.id)
                        ?.aspek?.bobot
                      return (
                        <td
                          key={index}
                          className='text-center border border-secondary border-top-0 border-left-0 border-right-0'
                        >
                          {nilai ?? 'Belum menilai'}
                        </td>
                      )
                    })}
                  </tr>
                ))}
                <tr style={{background: '#F5F7FA'}}>
                  <td className='fw-bold'>Total</td>
                  {data?.map((assessor: any, index: any) => {
                    return (
                      <td key={index} className='text-center fw-bold'>
                        {assessor.total_nilai ?? 'Belum menilai'}
                      </td>
                    )
                  })}
                </tr>
              </tbody>
            </table>
          </div>
          <div className='text-end'>
            <p className='px-5 py-3 fw-bold h4 text-primary'>
              Total Nilai {title}: {calculateTotalValue(data)}
            </p>
          </div>
        </div>
      </div>
    </div>
  )
}

const IndicatorAssessmentInterview: FC<Props> = ({data, title}) => {
  return <IndicatorAssessmentContent data={data} title={title} />
}

export default IndicatorAssessmentInterview
